<template>
  <div class="fts-builder-device">
    <div class="builder-device-web" v-show="device === 'web'">
      <iframe
        width="1440"
        height="768"
        frameborder="0"
        :src="webUrl"
        allow="local-network-access; local-network; loopback-network"
        class="builder-device-content"
        ref="webDeviceIframe"
      ></iframe>
    </div>

    <div class="builder-device-app" ref="builderDeviceApp" v-show="device === 'app'">
      <svg width="416" height="880" viewBox="0 0 416 880" fill="none" xmlns="http://www.w3.org/2000/svg" class="builder-device-frame-bg">
        <rect width="416" height="880" rx="68" fill="#171717"/>
      </svg>
      <iframe
        width="406"
        height="868"
        frameborder="0"
        :src="appUrl"
        allow="local-network-access; local-network; loopback-network"
        class="builder-device-content"
        ref="appDeviceIframe"
      ></iframe>
      <svg width="418" height="880" viewBox="0 0 418 880" fill="none" xmlns="http://www.w3.org/2000/svg" class="builder-device-frame">
        <path d="M411.278 813.441C411.278 846.316 385.342 873.074 353.451 873.074H64.5489C32.6748 873.074 6.72176 846.316 6.72176 813.441V66.5594C6.72176 33.6836 32.6748 6.92575 64.5489 6.92575H353.451C385.342 6.92575 411.278 33.6836 411.278 66.5594V813.441ZM353.451 0H64.5489C28.9052 0 0 29.7996 0 66.5594V813.441C0 850.2 28.9052 880 64.5489 880H353.451C389.095 880 418 850.2 418 813.441V66.5594C418 29.7996 389.095 0 353.451 0Z" fill="#212121"/>
      </svg>
    </div>
  </div>
</template>

<script>
let resizeObserver = null;

export default {
  props: {
    device: String,
    webUrl: String,
    appUrl: String
  },
  methods: {
    calcDevicePosition(el) {
      try { 
        this.$nextTick(() => {
          if (this.device === 'web') {
            this.$refs.webDeviceIframe.width = el.clientWidth;
            this.$refs.webDeviceIframe.height = el.clientHeight;
          } else if (this.device === 'app') {
            const scalePercent = el.clientHeight / this.$refs.builderDeviceApp.scrollHeight;
            if (1 > scalePercent) {
              this.$refs.builderDeviceApp.style.transform = `scale(${scalePercent})`;
              this.$refs.builderDeviceApp.style.transformOrigin = 'top center';
            } else {
              this.$refs.builderDeviceApp.style.transform = null;
              this.$refs.builderDeviceApp.style.transformOrigin = null;
            }
          }
        });
      } catch(err) {
        console.warn("[DOMException]:calcDevicePosition", err);
      }
    },
    getPostMessage(payload) {
      let message = { type: 'inistate' };
      if (Object.prototype.toString.call(payload) === "[object Object]") {
        message = { ...payload, ...message };
      }
      return JSON.stringify(message);
    },
    postActionToApp(payload) {
      const postMessage = this.getPostMessage(payload);
      console.info(`From Action Builder to APP`, postMessage);
      this.$refs.appDeviceIframe.contentWindow.postMessage(postMessage, "*");
    },
    postActionToWeb(payload) {
      const postMessage = this.getPostMessage(payload);
      console.info(`From Action Builder to WEB`, postMessage);
      this.$refs.webDeviceIframe.contentWindow.postMessage(postMessage, "*");
    },
    reload() {
      const appSrc = this.$refs.appDeviceIframe.src;
      const webSrc = this.$refs.webDeviceIframe.src;
      this.$refs.appDeviceIframe.src = '';
      this.$refs.webDeviceIframe.src = '';
      setTimeout(() => {
        this.$refs.appDeviceIframe.src = appSrc;
        this.$refs.webDeviceIframe.src = webSrc;
      }, 100);
    }
  },
  watch: {
    device() {
      this.calcDevicePosition(this.$el);
    }
  },
  mounted() {
    resizeObserver = new ResizeObserver(_.debounce((entries) => {
      try {
        const entry = entries.find(x => x.target ===this.$el);
        this.calcDevicePosition(entry.target);
      } catch(err) {
        console.warn("[DOMException]:ResizeObserver", err);
      }
    }), 300);
    resizeObserver.observe(this.$el);

    const webDeviceIframe = this.$refs.webDeviceIframe;
    webDeviceIframe.addEventListener('load', () => {
      webDeviceIframe.contentWindow.document.addEventListener('click', (evt) => {
        if (evt.target && evt.target.tagName === 'A') {
          if (location.origin !== evt.target.origin && evt.target.href && evt.target.target !== '_blank') {
            evt.preventDefault();
            window.open(evt.target.href);
          }
        }
      });
    });
  },
  beforeDestroy() {
    if (resizeObserver) {
      resizeObserver.unobserve(this.$el);
      resizeObserver.disconnect();
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-builder-device {
  height: 100%;
  display: flex;
  .builder-device-hidden {
    position: absolute;
    pointer-events: none;
    visibility: hidden;
    z-index: -1;
  }
  .builder-device-web {
    .builder-device-content {
      border: 1px solid var(--fts-border);
      border-radius: 0.5rem;
    }
  }
  .builder-device-app {
    position: relative;
    display: inline-flex;
    margin: auto;
    .builder-device-frame {
      pointer-events: none;
      z-index: 1;
    }
    .builder-device-frame-bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      pointer-events: none;
    }
    .builder-device-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 2.875rem;
    }
  }
}
</style>